import { render, staticRenderFns } from "./iadebiletfatura.vue?vue&type=template&id=62bab8d0&scoped=true"
import script from "./iadebiletfatura.vue?vue&type=script&lang=js"
export * from "./iadebiletfatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bab8d0",
  null
  
)

export default component.exports